<template>
    <div class="app-marketing-return">
        <div class="text-header">
            <h2 class="app-text">{{ translate('app.promotion.slogan') }}</h2>
        </div>

        <nuxt-resource :src="'images/occasion/app/delivery-page-app-2022.png'" class="app-image" />
        <div class="app-button mt-3 mb-3">
            <a
                class="mr-2"
                href="https://play.google.com/store/apps/details?id=com.dundle.app&referrer=utm_source%3Dwebsite%26utm_medium%3Dorder_page%26utm_term%3Dapp_campaign%26anid%3Dadmob"
                target="_blank"
                @click="trackPlaystoreClick"
                ><nuxt-resource
                    :src="`images/occasion/app/google-play-badge-${
                        isMarketingRegion('app') ? $locale.language : 'en'
                    }.svg`"
                    class="app-icon"
            /></a>
            <a
                href="https://apps.apple.com/app/dundle-prepaid-cards-egifts/id1605958640&referrer=utm_source%3Dwebsite%26utm_medium%3Dorder_page%26utm_term%3Dapp_campaign%26anid%3Dadmob"
                target="_blank"
                @click="trackAppstoreClick"
                ><nuxt-resource
                    :src="`images/occasion/app/app-store-badge-${
                        isMarketingRegion('app') ? $locale.language : 'en'
                    }.svg`"
                    class="app-icon"
            /></a>
        </div>
    </div>
</template>

<script>
import MarketingMixin from '~/mixins/MarketingMixin';
import TranslationMixin from '~/mixins/TranslationMixin';

export default {
    mixins: [MarketingMixin, TranslationMixin],
    methods: {
        trackPlaystoreClick() {
            this.$gtm?.push({ event: 'event_app_download_contact_or_order_google_play' });
        },
        trackAppstoreClick() {
            this.$gtm?.push({ event: 'event_app_download_contact_or_order_app_store' });
        },
    },
};
</script>

<style lang="scss" scoped>
.app-marketing-return {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .app-text {
        font-size: 1.4rem;
        @media screen and (min-width: 768px) {
            font-size: 1.8rem;
        }
    }

    .app-image {
        border-radius: $border-radius-default;
    }

    .app-button {
        display: flex;
        justify-content: center;
    }

    .app-icon {
        height: 2.8rem;
    }

    .text-header {
        height: 4.5rem;
    }
}
</style>

<i18n src="@dundle/locale/data/app-promotion.json"></i18n>
